export default "__VITE_ASSET__wm2EaUOF__"